import { useId, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import ModalShell from './ModalShell';

const Modal = styled(ModalShell)({
    '& .modal-base-paper': {
        outline: 'none',
        maxWidth: 500,
        width: 'calc(100% - 32px)',
    },
    '& .modal-base-header': {
        borderBottom: 'none',
    },
    '& .modal-base-content': {
        padding: 16,
    },
    '& .modal-base-footer': {
        borderTop: 'none',
    },
});

const ModalConfirm = ({
    isOpen,
    handleClose,
    title,
    description,
    onPrimaryAction,
    primaryActionText,
    primaryActionType,
    className,
    onSecondaryAction = null,
    secondaryActionText = null,
    onAdditionalAction = null,
    additionalTextButton = null,
    additionalButtonType,
    isLogout = false,
    aboveModal = false,
}) => {
    const { t } = useTranslation();

    const [isDisabled, setIsDisabled] = useState(false);
    const id = useId();
    const descriptionId = description ? id : undefined;

    const runAction = action => async () => {
        setIsDisabled(true);
        try {
            await action();
        } finally {
            if (!isLogout) {
                setIsDisabled(false);
            }
        }
    };

    const secondaryAction = onSecondaryAction || handleClose;

    return (
        <Modal
            isOpen={isOpen}
            className={className}
            title={title}
            descriptionId={descriptionId}
            aboveModal={aboveModal}
            onPrimaryAction={onPrimaryAction && runAction(onPrimaryAction)}
            primaryActionText={primaryActionText}
            primaryActionType={primaryActionType}
            primaryActionDisabled={isDisabled}
            onSecondaryAction={secondaryAction}
            secondaryActionText={secondaryActionText || t('buttons.cancel')}
            secondaryActionDisabled={isDisabled}
            onAdditionalAction={onAdditionalAction && runAction(onAdditionalAction)}
            additionalTextButton={additionalTextButton}
            additionalButtonType={additionalButtonType}
            additionalActionDisabled={isDisabled}
        >
            <Typography id={descriptionId} variant="body2" color="textSecondary">
                {description}
            </Typography>
        </Modal>
    );
};

export default ModalConfirm;
